import styled from 'styled-components';
import global from '../../global';

export const Container = styled.button`
  z-index: 10;
  width: 28px;
  height: 28px;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  
  @media(min-width: ${global.responsive.small.width.value + 1}${global.responsive.small.width.unit}) {
    display: none;
  }
`
